const equipmentStatuses = ['works', 'broken', 'decommissioned', 'moving', 'maintenance', 'shipment', 'repair', 'acceptance', 'in_storage_warehouse']
const equipmentJustStatuses = ['works', 'broken', 'decommissioned', 'repair']
const moveStatuses = ['usage', 'storage', 'moving', 'repair']
const staffStatuses = ['accepted', 'transferred', 'vacation', 'fired'];
const watchDogSettings = ['never', '3_days', '1_week', '2_weeks', '1_month', '2_months']
const maintenanceType = ['service', 'parts']

export { equipmentStatuses, equipmentJustStatuses, staffStatuses, moveStatuses, watchDogSettings, maintenanceType }